var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    clipPath: "url(#clip0_7_2689)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7_2689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.821 530.773C238.163 476.33 226.219 513.173 247.875 526.226C247.875 526.226 227.201 559.882 211.537 585.384C200.351 579.532 194.512 580.472 190.54 586.942C186.821 593.006 189.179 600.388 198.723 606.241C196.449 609.946 192.547 616.304 188.8 622.396C181.684 633.975 213.53 652.824 220.324 641.764C223.159 637.147 227.243 630.494 229.868 626.241C249.63 638.494 265.897 649.919 273.35 637.806C280.662 625.89 265.181 617.778 243.3 604.388C244.886 601.82 247.889 596.907 249.391 594.479C288.452 621.666 313.899 617.694 329.366 597.469C342.054 580.865 343.808 554.423 311.821 530.773ZM298.417 577.847C291.652 587.139 278.459 586.662 261.757 574.395C259.609 572.823 277.771 545.089 278.473 545.412C302.375 556.823 305.562 568.037 298.417 577.847Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.8 837.15C1499.92 844.462 1474.37 860.771 1462.99 869.515C1466.7 857.782 1467.4 849.08 1466.04 842.427C1477.99 835.339 1492.77 828.462 1485.81 816.448C1478.88 804.49 1466.05 813.388 1449.11 823.128C1439.31 818.356 1427.28 815.493 1418.24 809.051C1395.84 793.093 1437.71 747.941 1463.51 777.5C1468.88 783.661 1498.42 767.535 1487.02 751.703C1465.39 721.681 1408.14 736.98 1386.9 761.289C1363.11 788.531 1366.96 826.792 1399.25 837.487C1405.58 839.578 1411.41 841.009 1416.49 842.399C1406.4 849.403 1404.69 854.652 1408.5 861.234C1414.79 872.084 1425.98 865.333 1436.07 859.69C1436.08 866.441 1433.22 876.196 1426.62 890.835C1418.51 908.884 1436.6 922.035 1452.6 911.691C1476.17 896.463 1521.28 871.915 1534.75 864.097C1548.7 856.041 1531.99 827.564 1513.8 837.15Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.32 122.891C1101.45 91.2783 1123.88 58.9392 1116.43 50.6597C1108.98 42.3802 1074.46 61.2955 1039.33 92.9082C1004.2 124.521 981.767 156.86 989.217 165.14C996.668 173.419 1031.19 154.504 1066.32 122.891Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.75 207.358C1163.7 211.807 1159.2 216.27 1154.33 220.649C1126.09 246.067 1096.07 258.769 1087.3 249",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.07 135.763C1177.72 145.364 1162.18 173.434 1134.38 198.459C1106.57 223.484 1077.03 235.976 1068.38 226.375",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.125 167.217C1030.96 186.192 1069.56 225.323 1087.3 249",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.12 53.8254C1130.89 88.8996 1158.63 125.363 1179.92 147.623",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.68 233.112C1044.73 277.394 1072.2 300.103 1104.35 286.966C1205.03 245.828 1144.86 129.981 1210.22 125.391C1223.22 124.479 1217.62 135.749 1203.09 156.129C1186.9 178.838 1175.93 221.519 1144.9 258.39",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.264 1106.09L401.579 1155.51C392.61 1159.01 382.518 1154.57 379.024 1145.62L351.795 1075.81C348.3 1066.84 352.735 1056.75 361.69 1053.25L488.375 1003.83C497.343 1000.34 507.435 1004.77 510.93 1013.73L538.159 1083.54C541.668 1092.49 537.232 1102.6 528.264 1106.09Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.296 1079.65L512.432 1017.57",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.011 1037L360.876 1099.09",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.708 1069.21L481.661 1079.37L488.421 1096.69L514.468 1086.53L507.708 1069.21Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.689 823.732C656.942 809.458 647.089 791.367 653.938 786.482C664.788 778.749 672.381 802.567 669.784 812.756C668.619 817.318 686.992 826.3 688.887 818.637C690.262 813.079 690.627 805.598 687.581 796.489C693.139 793.065 697.954 791.493 693.925 783.773C690.094 776.419 686.065 778.749 680.1 781.486C659.889 751.268 631.467 766.44 633.671 789.023C635.453 807.226 642.036 816.027 642.976 823.886C643.692 829.936 637.011 835.76 629.628 827.62C622.793 820.083 620.94 805.612 622.821 793.093C624.351 782.973 602.807 781.149 600.996 792.644C599.592 801.542 600.729 811.605 604.393 821.149C599.971 823.872 597.192 826.469 600.35 832.546C603.677 838.932 607.48 837.641 612.281 835.522C634.513 865.459 667.272 848.785 660.689 823.732Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.959 889.572C712.901 887.368 743.302 815.76 719.33 769.752C695.357 723.758 619.228 707.66 575.648 766.187C546.341 752.376 549.766 782.566 564.082 791.1C560.868 826.946 580.055 865.964 612.912 884.8C611.705 901.417 634.485 921.516 639.959 889.572Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.853 788.756C739.274 792.756 740.032 776.054 733.028 762.608C726.025 749.162 711.905 740.222 708.059 752.699",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.436 778.187C751.934 773.935 761.942 796.939 768.44 794.44C774.237 792.223 778.644 781.963 768.061 774.005C780.904 765.008 773.535 732.46 749.927 735.394C749.632 710.537 728.495 712.741 726.305 716.769C724.593 719.927 731.246 737.962 722.782 750.061",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.239 747.057C736.116 755.324 730.839 758.412 730.839 758.412",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.177 770.3C749.913 768.026 743.134 768.054 736.018 769.991",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.192 350.616L894.69 392.259C896.697 393.255 899.069 393.143 900.964 391.95L915.435 382.827",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.76 343.921L803.248 346.658",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.287 328.356L790.364 339.191C789.704 339.598 789.114 340.103 788.609 340.707L775.332 356.637C771.177 361.746 774.588 368.202 778.742 370.406L896.809 430.407C902.185 432.989 907.406 433.326 912.74 430.056L951.857 404.526C956.573 401.452 957.892 395.136 954.804 390.434L949.022 381.592",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.813 422.982L900.009 403.712",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.609 341.128L994.37 331.177",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.636 384.02L962.103 390.027C965.963 392.048 970.608 391.824 974.258 389.438L1014.22 363.36C1019.26 360.076 1020.66 353.325 1017.37 348.3L1003.83 327.598C1003.16 326.559 1002.22 325.731 1001.11 325.198L897.609 274.531C895.518 273.506 893.034 273.618 891.041 274.825L879.686 281.576",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.888 307.149L922.719 349.465C924.726 350.462 927.098 350.349 928.993 349.156L959.829 329.703",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.789 301.113L830.126 303.275",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.331 323.5L864.429 274.095C861.257 272.538 857.51 272.706 854.492 274.531L818.379 296.37C817.719 296.777 817.129 297.282 816.624 297.885L803.178 314.012C800.413 317.38 799.852 324.356 805.929 327.163L926.607 388.497C930.186 390.42 935.786 390.518 939.267 388.217L979.717 361.816C984.518 358.686 985.865 352.244 982.735 347.444L969.443 327.135C968.433 325.577 967.015 324.328 965.331 323.5Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.814 380.02L928.01 360.806",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.971 259.246C999.858 260.383 1004.31 261.576 1009.67 263.008C1003.35 265.829 989.64 266.46 984.812 278.783C983.675 282.671 982.482 287.12 981.051 292.482C978.23 286.166 977.598 272.453 965.275 267.625C961.387 266.488 956.938 265.295 951.576 263.864C957.892 261.043 971.605 260.411 976.433 248.088C977.57 244.2 978.763 239.751 980.195 234.39C983.002 240.705 983.633 254.418 995.971 259.246Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.097 202.824C903.757 204.186 909.076 205.617 915.491 207.33C907.925 210.712 891.518 211.456 885.735 226.221C884.374 230.881 882.942 236.2 881.23 242.614C877.847 235.049 877.103 218.642 862.338 212.859C857.678 211.498 852.359 210.066 845.944 208.354C853.51 204.972 869.917 204.228 875.7 189.463C877.061 184.803 878.493 179.483 880.205 173.069C883.574 180.62 884.332 197.042 899.097 202.824Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.721 294.012C779.669 294.868 783.051 295.78 787.121 296.875C782.321 299.022 771.907 299.499 768.244 308.861C767.387 311.808 766.475 315.191 765.38 319.261C763.233 314.461 762.756 304.047 753.394 300.384C750.447 299.527 747.064 298.615 742.994 297.52C747.794 295.373 758.208 294.896 761.871 285.534C762.728 282.587 763.64 279.204 764.735 275.134C766.882 279.934 767.359 290.348 776.721 294.012Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.99 1002.37C986.314 983.594 972.04 934.471 994.637 896.463C1017.25 858.413 1067.23 847.536 1102.65 873.417",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.07 999.875C1049.14 1050.14 965.794 975.791 1008.17 904.519C1050.7 832.967 1157.03 871.298 1141.8 952.562",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.67 973.461C1069.64 1026.85 990.539 972.843 1025.15 914.611C1059.59 856.673 1144.4 899.593 1117.97 961.025",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.95 967.86C1076.6 963.903 1071.07 964.478 1065.76 963.187L1086.3 928.618C1087.64 930.091 1088.73 931.762 1089.56 933.558C1093.35 941.769 1106.39 934.681 1101.91 925.839C1096.52 915.186 1092.97 917.418 1094.6 914.681C1099.24 906.877 1087.75 897.923 1081.21 908.912C1066.6 904.926 1050.26 911.382 1041.82 925.572C1027.31 949.994 1046.3 967.636 1045.77 968.534C1040.95 976.618 1053 984.057 1058.06 976.113C1077.31 983.412 1079.3 971.818 1077.95 967.86ZM1073.25 922.302L1053.97 954.737C1044.94 940.492 1056.38 921.179 1073.25 922.302Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.49 1014.02C1113.74 989.363 1120.31 986.626 1110.67 973.461C1107.6 969.264 1102.88 964.015 1095.9 956.66C1128.41 960.941 1122.82 971.004 1153.27 942.078C1148.97 974.583 1138.92 968.997 1167.85 999.44C1135.34 995.145 1140.93 985.096 1110.49 1014.02Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.66 1023.55C1263.59 1009.26 1253.92 995.384 1247.71 975.187C1242.86 959.341 1263.61 948.927 1272.18 962.331",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.57 974.541C1287.57 929.474 1270.91 902.961 1264.16 891.41C1256.33 878.021 1272.86 866.357 1285.97 878.75C1322.56 913.347 1349.09 937.713 1362.07 951.201C1398.61 989.152 1399.53 1031.29 1398.05 1049.74C1395.18 1085.46 1361.36 1112.51 1322.45 1104.63C1297.83 1099.65 1274.34 1078.91 1263.77 1066.18C1253.21 1053.43 1242.29 1036.82 1233.47 1010.67C1226.79 990.864 1237.26 980.212 1249.42 981.208",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.58 1001.19C1266.32 958.274 1253.4 931.888 1243.5 907.916C1237.05 892.294 1253.57 878.512 1265.76 894.119",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.54 915.986C1317.79 899.93 1316.3 889.165 1316.37 875.228C1316.5 845.655 1289.22 863.789 1291.33 883.817",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344 978.036C1356.02 981.11 1356.96 969.924 1355.98 965.882",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.68 1003.93C1328.73 1007.06 1330.07 995.608 1329.09 991.58",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.31 1027.66C1301.37 1030.29 1303.28 1019.55 1302.3 1015.51",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.63 1048.03C1272.29 1051.57 1275.73 1042.46 1275.32 1038.87",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.92 865.052C1270.59 855.41 1285.73 852.743 1291.74 854.596",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.14 854.834C1263.24 840.785 1285.3 836.897 1294.06 839.606",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.65 516.513C517.33 545.173 450.296 546.324 442.984 544.079C436.962 542.24 398.701 515.811 378.911 482.871",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.843 466.997C435.376 470.113 448.317 473.663 463.125 478.197C513.4 493.608 552.84 510.408 551.212 515.727C549.584 521.061 507.491 512.892 457.216 497.481C434.955 490.66 414.828 483.572 399.445 477.327",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.681 645.399C429.145 649.736 438.001 655.168 437.075 658.158C436.05 661.498 423.334 660.544 408.653 656.052C393.986 651.561 382.912 645.217 383.936 641.877C384.666 639.491 391.389 639.294 400.54 641.02",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.236 542.928C428.274 578.718 416.204 635.841 387.234 640.262",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.745 545.229C435.601 581.609 413.06 636.866 436.373 655.94",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.51 539.433C461.471 539.433 467.925 532.979 467.925 525.019C467.925 517.058 461.471 510.604 453.51 510.604C445.549 510.604 439.096 517.058 439.096 525.019C439.096 532.979 445.549 539.433 453.51 539.433Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.588 516.906C467.027 502.857 498.242 477.776 519.716 481.369",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.989 477.182C436.546 464.586 461.115 439.669 454.865 421.53C448.614 403.39 413.911 398.897 377.353 411.494C340.795 424.091 316.227 449.008 322.477 467.147C328.728 485.286 363.431 489.779 399.989 477.182Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.481 476.625L422.786 530.17",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.353 431.389L330.783 466.056",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.496 422.28L388.877 426.856",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.441 424.498L374.827 417.62",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.649 467.263L385.241 431.642",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.069 424.4L400.961 410.94",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.708 475.67L381.255 432.596",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.445 429.719L429.72 451.165",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.921 432.765L376.736 428.287",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.7 479.53C1104.04 485.369 1101.81 491.362 1100.52 496.667L992.195 551.18",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.026 587.616C979.984 588.5 985.444 586.156 987.746 581.693C989.037 579.181 985.205 576.135 983.072 571.026",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.16 542.001C1052.03 545.145 1059.76 551.265 1070.11 546.156C1080.45 541.047 1086.56 530.464 1088.07 517.117C1088.66 511.896 1084.91 512.176 1082.21 515.854C1074.46 526.436 1064.24 535.868 1056.16 542.001Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.25 492.906C1104.7 478.899 1099.44 439.179 1115.03 408.189C1116.72 404.848 1120.72 403.403 1124.17 404.848C1135.67 409.662 1155.65 420.329 1165.8 430.659C1167.64 432.54 1168.24 435.305 1167.43 437.803L1149.94 492.19C1148.79 495.783 1145.03 497.86 1141.35 496.934C1135.43 495.446 1130.52 494.688 1125.66 494.52C1123.53 494.45 1121.38 495.194 1119.96 496.794C1117.35 499.741 1112.49 498.59 1110.25 492.906Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.92 495.825C1116.62 472.232 1127.99 440.217 1141.79 413.55",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.11 526.296C1006.01 507.783 1005.94 479.586 1017.63 456.316C1019.33 452.933 1023.34 451.46 1026.83 452.919C1036.81 457.102 1053.17 465.677 1063.94 474.618",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.84 507.348C1030.22 491.98 1036.95 476.007 1044.42 461.593",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.26 441.452C1179.09 441.593 1217.09 427.347 1233.44 436.301C1241.87 441.186 1253.87 465.397 1258.66 475.6C1259.83 478.085 1258.67 481.116 1256.06 482.407C1253.41 483.713 1250.25 482.73 1249.03 480.218C1246.95 475.937 1244.71 471.362 1244.46 470.856C1238.34 458.449 1225.73 452.147 1216.31 456.793C1206.9 461.439 1204.23 475.263 1210.36 487.685C1210.66 488.288 1212.33 491.629 1214.13 495.18C1215.89 498.674 1214.31 503.011 1210.59 504.85L1145.84 536.794C1144.17 537.622 1142.18 537.005 1141.42 535.419C1139.15 530.731 1136.31 524.934 1136.03 524.359C1129.91 511.952 1117.31 505.65 1107.89 510.296C1098.47 514.941 1095.81 528.766 1101.94 541.187C1102.33 541.973 1105.13 547.573 1107.46 552.121C1108.3 553.763 1107.5 555.798 1105.71 556.598C1093.66 561.988 1012.41 602.634 987.788 614.788C971.563 622.789 968.994 607.266 975.296 586.184C983.282 559.475 1018.22 506.45 1052.6 482.155C1069.11 470.491 1086.78 461.144 1104.72 454.786",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.9 498.871C1126.87 502.562 1134.77 509.818 1141.13 520.387C1143.48 524.303 1146.85 522.562 1150.95 520.555L1189.06 502.043C1191.79 500.709 1193.66 498.071 1193.98 495.039C1195.96 476.204 1192.24 445.144 1180.69 439.291",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.8 527.966C1141.41 539.335 1137.84 551.026 1128.82 555.489C1122.07 558.83 1113.94 557.258 1107.43 552.163",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092 563.321C1097.9 566.717 1104.61 567.419 1110.35 564.584C1113.34 563.11 1124.47 557.623 1128.82 555.475",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.9 581.946C1053.05 588.767 1049.5 594.62 1043.72 597.469C1037.99 600.29 1031.28 599.602 1025.4 596.22",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.9 605.315C1012.8 608.711 1019.51 609.413 1025.25 606.578C1028.24 605.104 1039.37 599.616 1043.72 597.469",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.22 474.463C1249.83 485.832 1246.27 497.523 1237.24 501.987C1230.49 505.327 1222.36 503.755 1215.85 498.66",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.43 509.818C1206.32 513.215 1213.03 513.917 1218.77 511.082C1221.76 509.608 1232.89 504.12 1237.24 501.973",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.51 456.274C1168.21 452.961 1177.56 486.155 1174.92 493.046C1172.29 499.938 1147.16 509.58 1138.52 514.717",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.665 343.753L627.397 329.366C623.228 327.71 618.554 327.78 614.442 329.563L578.623 345.044C574.497 346.826 571.255 350.167 569.598 354.349L555.212 390.617C553.556 394.785 553.626 399.459 555.408 403.571L570.89 439.389C572.672 443.516 576.013 446.758 580.195 448.414L616.463 462.8C620.632 464.456 625.305 464.386 629.418 462.604L665.237 447.123C669.363 445.34 672.605 442 674.262 437.817L688.648 401.55C690.304 397.382 690.234 392.708 688.451 388.595L672.97 352.777C671.188 348.651 667.833 345.409 663.665 343.753Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.882 361.03L625.586 351.388C622.793 350.279 619.663 350.321 616.898 351.514L592.897 361.886C590.132 363.079 587.957 365.325 586.848 368.118L577.22 392.413C576.111 395.206 576.153 398.336 577.346 401.101L587.718 425.101C588.911 427.866 591.157 430.042 593.95 431.15L618.246 440.779C621.039 441.887 624.169 441.845 626.934 440.652L650.934 430.28C653.699 429.087 655.875 426.842 656.984 424.049L666.612 399.754C667.721 396.96 667.679 393.831 666.486 391.066L656.114 367.065C654.921 364.3 652.689 362.139 649.882 361.03Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.7 351.949L585.248 360.328",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.097 394.939L673.139 395.178",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.272 439.909L658.71 431.529",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.875 396.918L570.834 396.694",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.875 396.918L570.834 396.694",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.272 439.909L658.71 431.529",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.793 459.151L622.555 447.179",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.77 350.742L657.391 359.304",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.188 441.452L586.567 432.905",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.165 333.058L621.404 345.03",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.071 379.416L588.631 406.827",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.713 393.915L595.073 414.07",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.91 388.638L648.983 390.771",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.958 343.444C352.033 319.654 292.242 290.18 235.664 255.541C227.65 250.642 224.661 240.116 228.899 232.2C247.539 197.21 266.178 162.22 284.817 127.23C289.056 119.3 298.614 116.816 306.277 121.518C360.455 154.88 417.818 183.161 477.273 205.828C485.68 209.028 489.526 218.137 485.82 226.333C469.413 262.418 453.005 298.517 436.597 334.602C432.878 342.77 422.716 346.812 413.958 343.444Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.753 239.33C398.505 245.927 433.875 253.085 456.275 253.955C470.592 254.502 476.43 246.951 482.283 234.067",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.655 138.767C270.529 152.901 272.171 161.252 279.315 168.269C296.368 185.027 323.457 208.256 341.689 222.081",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.079 253.379L340.524 244.228C336.187 242.095 334.405 236.846 336.538 232.509L343.808 217.758C345.942 213.421 351.191 211.638 355.528 213.772L374.083 222.923C378.42 225.056 380.203 230.305 378.069 234.642L370.799 249.393C368.651 253.73 363.402 255.513 359.079 253.379Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.358 182.066C429.173 164.957 431.011 160.031 424.274 156.115C417.537 152.199 385.185 136.255 377.971 133.279C370.757 130.304 367.964 134.767 359.767 152.185",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.997 176.789C416.092 166.992 416.555 165.21 411.937 162.585C407.305 159.96 385.241 149.083 380.343 147.006C375.445 144.929 374.322 146.388 369.648 156.395",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.865 253.814C450.254 277.113 439.475 300.734 429.116 323.542C425.776 330.91 420.583 333.76 412.695 330.728C357.268 310.208 298.151 280.594 247.23 249.435C240.015 245.028 238.275 238.895 242.079 231.765C253.518 210.291 265.378 187.891 277.097 165.827",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.113 1033.78C666.724 979.482 731.948 946.836 749.997 880.828C782.953 904.982 815.894 929.137 848.85 953.278C858.492 960.338 842.913 972.759 827.951 978.443C842.618 984.436 864.64 1005.97 854.815 1019.4C819.094 1068.17 760.454 1100.75 743.499 1162.78C709.561 1131.37 676.044 1100.24 642.878 1069.38",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.85 953.278C862.956 964.689 865.033 1004.21 854.815 1019.4",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.503 1015.58L712.508 971.72",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.287 1043.02L775.879 1023.19",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.041 1047.19L662.023 1026.68",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.989 1000.03L697.139 987.58",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.553 1060.84L719.975 1006.72",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.93 1035.17L680.69 1004.21",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.921 1078.73L731.442 1047.55",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.426 980.969L726.081 957.025",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.487 1027.57L767.921 990.036",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.516 994.906L759.598 945.867",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.983 1068.51C647.945 1064.3 653.868 1050.74 652.071 1042.84",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.994 1038.11C616.084 1026.91 579.255 1019.05 576.504 1025.43C573.753 1031.82 604.715 1053.22 630.625 1064.42C650.205 1072.89 664.759 1075.17 672.058 1072.66C675.412 1083.23 685.911 1086.09 695.273 1082.35C704.578 1078.61 714.235 1084.09 715.765 1080.55C706.305 1069.1 689.462 1059.33 676.62 1063.17C673.812 1056.04 662.079 1046.78 641.994 1038.11Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.392 1070.77C695.02 1070.77 707.189 1075.54 714.53 1080.38",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.87 636.922C683.132 645.357 640.141 652.164 596.898 657.329C590.511 658.073 583.901 653.582 582.343 647.308C576.364 622.887 572.448 598.142 570.595 573.061C570.132 566.619 575.03 560.303 581.346 559.04C624.084 550.605 667.075 543.798 710.319 538.633C716.705 537.875 723.316 542.38 724.874 548.654C730.853 573.075 734.769 597.82 736.622 622.901C737.085 629.357 732.186 635.659 725.87 636.922Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.777 575.419C572.335 581.693 640.955 610.325 655.201 608.08C669.447 605.82 725.884 557.398 725.421 550.956",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.781 598.157C694.697 606.508 721.491 622.325 733.562 632.136",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.111 655.154C596.561 642.087 617.165 618.774 633.53 604.683",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.619 799.76C885.673 799.76 897.876 787.556 897.876 772.503C897.876 757.45 885.673 745.247 870.619 745.247C855.565 745.247 843.362 757.45 843.362 772.503C843.362 787.556 855.565 799.76 870.619 799.76Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.251 798.918C867.208 806.707 866.507 812.616 862.815 830.904C860.359 832.715 856.106 831.662 854.548 829.037C858.254 810.749 860.443 805.332 848.695 791.914",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.372 556.865L946.383 744.868C960.152 765.57 967.029 750.061 981.121 733.022C994.721 716.558 1004.87 707.253 1021.59 723.941C1038.81 741.12 1046.37 764.461 1016.08 779.072C985.809 793.682 967.296 797.977 936.263 751.759L818.028 563.391",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.819 773.065C962.889 764.04 975.549 754.861 984.967 743.45C994.062 732.446 1000.85 726.215 1012.04 737.373C1023.56 748.868 1029.18 762.721 1008.93 772.489C988.672 782.286 978.735 782.089 970.819 773.065Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.972 559.012L821.045 562.156C816.596 564.935 810.729 563.588 807.936 559.138L759.485 481.734C756.706 477.285 758.054 471.418 762.503 468.625L767.43 465.481C771.879 462.702 777.746 464.049 780.539 468.498L828.99 545.903C831.769 550.366 830.421 556.233 825.972 559.012Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.067 178.782C608.224 182.74 587.227 185.505 566.061 187.048C561.949 187.329 558.384 183.062 559.914 179.455C567.395 161.701 577.051 142.248 585.585 123.104C587.241 119.398 591.985 118.809 594.511 121.995C607.466 138.332 621.53 154.627 633.081 169.897C635.439 172.999 633.081 177.996 629.067 178.782Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.791 159.385C755.948 163.343 734.951 166.108 713.786 167.652C709.673 167.932 706.108 163.666 707.638 160.059C715.119 142.304 724.776 122.851 733.309 103.707C734.965 100.002 739.709 99.412 742.236 102.598C755.191 118.935 769.254 135.23 780.805 150.501C783.163 153.602 780.819 158.599 776.791 159.385Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.2 162.276C631.116 161.855 635.018 161.42 638.934 160.971C641.573 160.676 643.425 158.388 643.243 155.666C641.994 137.883 651.384 122.865 664.535 121.125C677.7 119.412 690.641 131.497 694.024 148.999C694.557 151.68 696.929 153.406 699.554 153.013C703.484 152.437 707.4 151.834 711.329 151.23",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.383 113.896C722.768 103.51 716.424 93.0821 709.757 82.6118C708.508 80.6469 706.22 79.496 704.045 79.7205C699.708 80.1837 695.385 80.6609 691.062 81.1521C687.202 81.5872 685.953 95.1594 682.093 95.6225C669.588 97.1243 657.11 98.7664 644.647 100.521C641.166 101.012 635.088 88.3943 631.608 88.9137C626.288 89.6996 620.983 90.4996 615.677 91.3277C613.516 91.6646 611.607 93.3769 610.905 95.5945C607.228 107.272 603.817 118.823 601.094 130.163",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.623 244.193C627.005 241.385 642.258 223.271 639.693 203.735C637.127 184.198 617.714 170.636 596.332 173.444C574.951 176.252 559.697 194.365 562.263 213.902C564.828 233.439 584.241 247.001 605.623 244.193Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.348 224.792C774.729 221.984 789.983 203.87 787.417 184.334C784.852 164.797 765.439 151.235 744.057 154.043C722.675 156.851 707.422 174.964 709.987 194.501C712.553 214.038 731.966 227.6 753.348 224.792Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.2 216.888C650.668 216.452 689.925 211.737 721.561 205.028",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.942 156.002C652.029 143.848 657.798 133.658 666.037 132.577C674.276 131.511 682.472 139.862 684.732 151.834L652.942 156.002Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.605 214.389C658.093 201.393 656.282 188.298 655.201 175.104C655.019 172.718 656.787 170.318 659.131 169.813C667.258 168.101 675.455 167.02 683.736 166.585C686.136 166.473 688.466 168.339 688.901 170.683C691.259 183.708 692.901 196.817 693.827 210.038",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.926 219.582C606.063 220.803 599.157 221.716 592.196 222.305C589.332 222.544 586.455 220.382 585.908 217.561C584.897 212.228 584.195 206.852 583.788 201.449C583.592 198.585 585.824 195.75 588.645 195.245C595.508 194.024 602.414 193.112 609.375 192.522C612.238 192.298 615.116 194.445 615.663 197.266C616.674 202.6 617.375 207.975 617.783 213.379C617.965 216.256 615.747 219.077 612.926 219.582Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.65 200.186C753.787 201.407 746.882 202.319 739.92 202.908C737.057 203.147 734.179 200.986 733.632 198.164C732.621 192.831 731.92 187.455 731.513 182.052C731.316 179.189 733.548 176.354 736.369 175.848C743.232 174.627 750.138 173.715 757.099 173.125C759.963 172.901 762.84 175.048 763.387 177.869C764.398 183.203 765.1 188.578 765.507 193.982C765.703 196.859 763.472 199.68 760.65 200.186Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.304 120.016L581.795 62.8501",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.266 81.6574C569.711 75.8327 558.159 92.8154 543.605 86.9908C545.429 84.7171 547.184 81.91 548.896 78.724C546.356 75.5801 543.773 72.0572 541.106 67.987C555.661 73.8116 567.212 56.8289 581.767 62.6536",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.029 100.619L729.534 43.4533",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.004 62.2746C717.449 56.45 705.898 73.4327 691.343 67.608C693.167 65.3343 694.922 62.5273 696.634 59.3413C694.094 56.1973 691.511 52.6745 688.844 48.6042C703.399 54.4289 714.951 37.4462 729.506 43.2708",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.54 602.915L1413.68 591.532C1408.8 588.023 1407.69 581.23 1411.18 576.346L1448.55 524.303C1452.06 519.419 1458.85 518.31 1463.73 521.805L1480.38 533.749",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.71 643.898L1429.67 623.055C1424.78 619.546 1423.68 612.753 1427.17 607.869L1438.51 592.079C1442.02 587.195 1448.81 586.086 1453.7 589.581L1482.56 610.297",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1503.52 581.469L1474.48 560.626C1469.6 557.117 1468.49 550.324 1471.99 545.44L1483.33 529.65C1486.84 524.766 1493.63 523.657 1498.51 527.152L1527.37 547.868",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.67 571.504L1400.77 561.538C1395.89 558.03 1394.78 551.237 1398.27 546.352L1416 521.65C1419.51 516.766 1426.3 515.657 1431.18 519.152L1445.08 529.117",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.93 545.44L1380 531.84C1375.11 528.331 1382.71 526.562 1365.74 514.38C1351.29 504.022 1360.39 490.365 1375.3 501.06C1392.73 513.566 1391.51 505.481 1396.39 508.976L1415.32 522.576",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.52 499.825L1315.88 468.498",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.46 556.149C1405.68 554.156 1408.59 551.237 1408.63 551.096C1410.79 548.079 1415.35 551.349 1413.19 554.366C1413.07 554.521 1411.14 558.072 1408.46 556.149ZM1415.18 541.973C1415.37 541.833 1417.11 538.17 1419.93 540.191C1422.71 542.198 1419.8 545.103 1419.75 545.243C1417.57 548.261 1413.02 544.991 1415.18 541.973ZM1422.55 531.713L1423.37 530.577C1425.53 527.559 1430.09 530.829 1427.93 533.847L1427.11 534.984C1424.95 538.001 1420.39 534.731 1422.55 531.713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.45 586.76C1421.67 584.767 1424.57 581.848 1424.62 581.707C1426.78 578.704 1431.35 581.96 1429.18 584.977C1429 585.118 1427.25 588.781 1424.45 586.76ZM1431.8 576.5C1429.02 574.507 1431.93 571.588 1431.97 571.447C1432.87 570.184 1434.62 569.904 1435.89 570.802C1438.67 572.795 1435.76 575.714 1435.72 575.855C1434.82 577.118 1433.07 577.398 1431.8 576.5ZM1438.53 562.324L1439.34 561.188C1441.5 558.17 1446.06 561.44 1443.9 564.458L1443.09 565.595C1440.93 568.612 1436.36 565.342 1438.53 562.324ZM1445.89 552.065C1446.06 551.938 1447.82 548.261 1450.62 550.282C1453.4 552.275 1450.5 555.195 1450.46 555.335C1449.56 556.598 1443.73 555.068 1445.89 552.065ZM1453.26 541.791C1453.45 541.65 1455.17 537.987 1457.99 540.008C1460.77 542.001 1457.87 544.921 1457.82 545.061C1456.93 546.324 1451.1 544.808 1453.26 541.791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1560.14 706.172L1473.59 644.038",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1574.17 686.621L1487.62 624.487",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.96 643.743L1518.4 581.609",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.98 624.192L1532.44 562.058",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1501.43 564.823L1480.42 549.735",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.1 551.363L1490.09 536.275",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.62 627.252L1435.61 612.164",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1466.29 613.778L1445.28 598.704",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.24 666.214L1507.64 593.988C1502.75 590.479 1501.64 583.686 1505.14 578.802L1525.53 550.38C1529.04 545.496 1535.83 544.387 1540.72 547.882L1641.33 620.108L1563.41 728.629L1462.81 656.403C1457.92 652.894 1456.81 646.101 1460.31 641.217L1480.7 612.795C1484.21 607.911 1491 606.802 1495.89 610.297L1596.5 682.523",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.795 891.48C381.087 897.824 393.214 897.235 401.565 892.322C409.916 887.41 410.365 879.929 414 866.778C417.635 853.627 413.663 848.336 412.091 837.95C410.519 827.578 406.477 816.279 401.888 806.833C397.298 797.388 400.358 792.096 391.557 777.093C382.757 762.089 368.483 756.952 349.97 753.289C331.457 749.626 309.562 760.854 297.856 773.458C290.979 780.868 282.585 794.132 281.687 809.402C281.224 817.374 287.498 825.837 284.494 835.115C281.505 844.392 272.718 853.796 273.069 867.073C273.364 878.133 281.645 886.343 275.273 892.982",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.365 880.308C416.611 890.301 411.572 899.27 403.474 906.625C392.301 916.772 341.408 923.86 324.285 886.694C318.965 875.143 320.172 869.768 320.172 869.768",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.264 865.698C324.903 869.964 314.067 873.627 307.512 859.648",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.597 893.487C418.604 903.663 421.144 919.972 400.947 928.884C377.873 939.074 334.882 931.944 327.682 892.856",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.158 890.049C422.59 893.502 435.924 897.361 444.57 903.817",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.856 783.338C401.284 791.802 403.193 803.409 410.87 814.258C418.548 825.093 431.91 828.209 434.843 839.185C438.969 854.596 427.222 861.276 430.281 869.206C435.404 882.498 428.204 885.698 424.078 893.305",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.572 914.288C312.102 919.705 321.955 900.533 317.506 886.105C314.404 876.014 304.944 879.143 304.537 870.568C304.018 859.662 321.029 841.866 320.173 817.921C319.667 803.535 306.446 795.339 306.404 783.521C306.39 779.184 307.316 770.58 317.337 767.745C327.373 764.91 350.967 759.17 354.082 754.131",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.12 815.858C342.742 804.223 354.798 812.195 361.521 809.163",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.413 798.763C380.848 798.932 389.34 789.584 396.007 796.068",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.686 860.153C377.241 865.445 399.937 858.694 400.919 849.613",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.802 839.367C368.146 843.957 382.28 845.697 391.613 837.781C399.824 830.806 372.174 813.388 376.946 806.665",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.736 814.792C386.821 814.792 388.512 813.101 388.512 811.016C388.512 808.931 386.821 807.241 384.736 807.241C382.651 807.241 380.961 808.931 380.961 811.016C380.961 813.101 382.651 814.792 384.736 814.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.896 824.181C348.805 826.735 356.44 824.504 360.104 818.595",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.627 810.258C382.631 806.539 389.199 803.184 393.143 808.419",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.377 946.038C444.722 929.926 472.377 868.853 454.146 809.626C435.916 750.4 378.703 715.448 326.359 731.56C274.014 747.672 246.359 808.745 264.59 867.972C282.82 927.198 340.033 962.15 392.377 946.038Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.145 971.272C466.122 950.964 501.351 875.191 478.83 802.029C456.31 728.866 384.569 686.019 318.592 706.326C252.614 726.634 217.386 802.407 239.906 875.569C262.426 948.732 334.167 991.579 400.145 971.272Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.82 796.139C1242.5 796.139 1281.97 756.67 1281.97 707.983C1281.97 659.296 1242.5 619.827 1193.82 619.827C1145.13 619.827 1105.66 659.296 1105.66 707.983C1105.66 756.67 1145.13 796.139 1193.82 796.139Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.82 773.065C1229.76 773.065 1258.9 743.926 1258.9 707.983C1258.9 672.039 1229.76 642.901 1193.82 642.901C1157.87 642.901 1128.73 672.039 1128.73 707.983C1128.73 743.926 1157.87 773.065 1193.82 773.065Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.65 662.944L1203.84 714.579L1192.13 718.944L1172.96 667.309L1176.65 659.224L1184.65 662.944Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1188.89 710.2L1179.08 713.836",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.43 691.126L1200.59 705.878",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.08 728.643L1247.12 732.306",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.52 683.646L1147.79 686.972",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.48 662.705L1218.15 654.677",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.49 761.275L1172.8 754.005",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.42 751.155C1284.96 758.72 1277.94 762.917 1272.74 760.531C1267.53 758.145 1270.58 752.138 1274.01 744.573C1277.47 737.008 1280.01 730.776 1285.23 733.148C1290.44 735.548 1291.87 743.604 1288.42 751.155Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.32 381.901C1286.51 388.609 1283.28 389.283 1276.57 393.101C1252.5 406.757 1220.23 395.332 1204.48 367.571C1188.73 339.809 1195.47 306.25 1219.54 292.594C1243.61 278.938 1221.94 291.233 1232.9 285.015",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.99 385.513C1314.06 371.857 1320.8 338.284 1305.05 310.526C1289.3 282.768 1257.02 271.337 1232.95 284.993C1208.88 298.65 1202.14 332.223 1217.89 359.98C1233.64 387.738 1265.92 399.17 1289.99 385.513Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.3 360.483C1265.05 360.525 1247.75 312.524 1247.75 312.524C1259.15 309.857 1269.66 306.391 1274.2 319.065C1278.73 331.738 1265.27 333.451 1256.62 335.472",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.38 345.339L1273.75 340.075",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.043 879.564C951.885 871.368 941.428 863.087 930.986 855.424C928.109 853.318 924.193 853.332 921.343 855.452C910.831 863.255 901.118 871.957 893.75 880.196C890.985 883.284 892.093 888.491 898.073 889.08C901.497 889.417 905.862 888.449 909.61 888.617C909.427 898.554 908.361 920.084 889.862 931.846C887.321 933.46 887.335 938.386 892.571 938.386C932.024 938.386 941.176 903.186 943.632 888.73C947.562 888.561 950.692 889.53 954.313 889.066C961.176 888.224 961.766 882.68 959.043 879.564Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.404 1025.1C289.042 1044.63 254.991 1055.97 232.914 1040.87C210.836 1025.77 209.053 989.924 222.415 970.387L302.404 1025.1Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.191 1093.95C243.356 1086.4 236.9 1068.61 221.25 1057.9C205.6 1047.19 186.666 1047.64 181.501 1055.19L238.191 1093.95Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.39 977.98C222.611 953.587 194.947 933.937 189.052 960.548C181.95 992.591 214.934 1010.47 214.934 1010.47L216.787 1018.74C220.955 1032.89 226.162 1042.44 216.829 1055.17L225.405 1061.04C233.896 1047.72 244.675 1049.11 259.385 1047.86L267.764 1046.58C267.764 1046.58 296.382 1070.84 323.681 1052.61C346.349 1037.46 317.997 1018.81 297.168 1032.51",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.847 1032.21L235.847 1024L241.7 1028.02L256.451 1006.44L246.893 1007.86",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.387 346.953C238.317 344.833 242.275 342.742 246.247 340.665C248.633 339.43 251.623 340.749 252.114 343.275C252.928 347.514 253.728 351.809 254.528 356.16C254.725 357.255 255.398 358.209 256.353 358.77C260.171 361.002 263.946 363.234 267.652 365.437C269.869 366.757 270.08 370.013 268.087 371.837C264.774 374.869 261.448 377.858 258.107 380.834C257.265 381.578 256.774 382.659 256.76 383.795C256.704 388.329 256.676 392.848 256.676 397.339C256.676 400.034 254.093 401.845 251.567 400.918C247.356 399.389 243.103 397.859 238.837 396.357C237.756 395.978 236.577 396.062 235.594 396.596C231.664 398.715 227.706 400.806 223.734 402.883C221.348 404.118 218.359 402.799 217.867 400.273C217.053 396.034 216.253 391.739 215.453 387.388C215.257 386.294 214.583 385.339 213.629 384.778C209.811 382.546 206.035 380.315 202.33 378.111C200.112 376.792 199.916 373.536 201.895 371.711C205.207 368.679 208.534 365.69 211.874 362.714C212.716 361.97 213.208 360.89 213.222 359.753C213.278 355.22 213.306 350.7 213.306 346.209C213.306 343.514 215.888 341.703 218.415 342.63C222.625 344.16 226.878 345.69 231.145 347.191C232.212 347.57 233.391 347.486 234.387 346.953Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.293 930.962C564.293 932.941 568.293 934.948 572.293 936.983C574.679 938.204 575.353 941.404 573.57 943.271C570.595 946.401 567.563 949.544 564.475 952.716C563.703 953.516 563.31 954.611 563.409 955.72C563.802 960.127 564.181 964.492 564.532 968.787C564.742 971.355 562.216 973.418 559.577 972.857C555.184 971.917 550.805 970.948 546.454 969.952C545.359 969.699 544.194 969.924 543.254 970.583C539.534 973.166 535.829 975.762 532.18 978.373C529.99 979.931 527.015 978.878 526.299 976.296C525.106 971.973 523.871 967.636 522.621 963.285C522.299 962.19 521.541 961.278 520.544 960.787C516.544 958.808 512.544 956.801 508.544 954.766C506.158 953.544 505.484 950.344 507.267 948.478C510.242 945.348 513.274 942.204 516.362 939.032C517.134 938.232 517.527 937.137 517.428 936.028C517.035 931.621 516.656 927.256 516.305 922.962C516.095 920.393 518.621 918.33 521.26 918.891C525.653 919.832 530.032 920.8 534.383 921.797C535.478 922.049 536.643 921.825 537.583 921.165C541.303 918.583 545.008 915.986 548.657 913.375C550.847 911.818 553.822 912.87 554.538 915.453C555.731 919.776 556.966 924.112 558.216 928.463C558.524 929.558 559.282 930.47 560.293 930.962Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.2 969.11C1475.44 967.72 1479.71 966.359 1483.99 965.011C1486.56 964.211 1489.26 966.036 1489.29 968.618C1489.35 972.927 1489.38 977.306 1489.39 981.727C1489.39 982.836 1489.88 983.889 1490.72 984.619C1494.09 987.496 1497.42 990.345 1500.68 993.166C1502.63 994.85 1502.25 998.093 1499.99 999.538C1496.18 1001.94 1492.38 1004.3 1488.58 1006.64C1487.62 1007.23 1486.95 1008.21 1486.74 1009.32C1485.9 1013.77 1485.07 1018.22 1484.27 1022.63C1483.79 1025.28 1480.94 1026.6 1478.61 1025.25C1474.74 1023.01 1470.82 1020.76 1466.88 1018.51C1465.88 1017.95 1464.7 1017.83 1463.64 1018.18C1459.4 1019.57 1455.13 1020.93 1450.85 1022.28C1448.28 1023.08 1445.57 1021.25 1445.54 1018.67C1445.49 1014.36 1445.46 1009.98 1445.45 1005.56C1445.45 1004.45 1444.95 1003.4 1444.11 1002.67C1440.74 999.791 1437.42 996.942 1434.16 994.121C1432.21 992.436 1432.59 989.194 1434.85 987.749C1438.65 985.348 1442.46 982.991 1446.26 980.647C1447.21 980.057 1447.89 979.075 1448.1 977.966C1448.94 973.517 1449.77 969.068 1450.57 964.66C1451.05 962.008 1453.89 960.688 1456.22 962.036C1460.1 964.281 1464.01 966.527 1467.96 968.773C1468.95 969.334 1470.13 969.46 1471.2 969.11Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.11 202.347C1377.79 196.522 1380.78 192.887 1383.51 195.343C1384.83 196.536 1386.97 195.75 1387.38 194.024C1389.75 183.989 1379.23 175.104 1366.92 179.498C1354.61 183.891 1352.09 197.435 1360.28 203.708C1361.68 204.789 1363.84 204.031 1364.11 202.277C1364.66 198.656 1369.27 199.582 1371.94 204.929C1373.22 207.54 1379.76 205.196 1379.11 202.347Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.72 171.072C1344.98 169.91 1346.6 166.127 1345.35 162.622C1344.1 159.118 1340.45 157.22 1337.19 158.382C1333.93 159.544 1332.31 163.327 1333.56 166.831C1334.81 170.336 1338.46 172.234 1341.72 171.072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1381.08 157.021C1384.33 155.858 1385.96 152.075 1384.71 148.571C1383.46 145.067 1379.8 143.169 1376.55 144.331C1373.29 145.493 1371.66 149.276 1372.91 152.78C1374.17 156.284 1377.82 158.183 1381.08 157.021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.99 72.0573C1390.68 60.8571 1370.87 71.0046 1372.47 93.826C1355.17 90.3733 1320.75 101.616 1308.33 116.718C1295.11 98.0506 1273.36 102.724 1267.84 121.714C1262.59 139.735 1272.79 153.041 1290.65 148.606C1284.75 177.715 1308.81 235.204 1342.9 211.709C1354.65 237.884 1372.64 225.744 1377.81 217.842C1378.86 216.242 1380.81 215.554 1382.64 216.158C1391.66 219.161 1413.54 217.547 1405.91 189.224C1445.22 190.95 1432.87 127.427 1406.38 107.286C1422.99 99.4401 1422.45 82.682 1406.99 72.0573Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519.47 98.0042C1521.71 95.1297 1521.36 91.1127 1518.69 89.0318C1516.01 86.9509 1512.03 87.5942 1509.79 90.4687C1507.56 93.3432 1507.91 97.3603 1510.58 99.4412C1513.25 101.522 1517.23 100.879 1519.47 98.0042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.93 124.059C1555.17 121.184 1554.81 117.167 1552.14 115.086C1549.47 113.005 1545.49 113.649 1543.25 116.523C1541.01 119.398 1541.36 123.415 1544.04 125.496C1546.71 127.577 1550.69 126.933 1552.93 124.059Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1483.44 168.915C1506.13 186.585 1515.61 174.234 1526.58 156.648C1538.57 152.423 1533.9 140.76 1526.02 140.564C1510.56 140.171 1504.68 135.595 1500.49 120.69C1498.37 113.11 1485.91 111.44 1484.76 124.086C1470.65 138.767 1460.48 151.034 1483.44 168.915Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1480.34 141.953C1477.83 147.918 1479.3 154.122 1489.04 161.701C1498.6 169.139 1504.9 169.21 1510.08 165.448",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.94 146.922C1547.61 141.027 1559.96 133.518 1568.51 125.7C1569.08 128.732 1570.52 132.156 1572.73 135.455C1577.79 142.964 1585.01 146.936 1588.89 144.325C1592.76 141.728 1591.79 133.532 1586.74 126.023C1583.64 121.419 1579.72 118.149 1576.26 116.9C1584.3 103.777 1577.6 83.3136 1560.41 69.9239C1543.23 56.5482 1521.77 55.0745 1511.01 66.0642C1508.93 63.0466 1504.84 60.0851 1499.66 58.2325C1491.14 55.1728 1482.98 56.2535 1481.39 60.6465C1479.8 65.0396 1485.45 71.0748 1493.95 74.1204C1497.64 75.4398 1501.26 75.9871 1504.32 75.8327C1498.85 86.0364 1494.63 99.805 1492.27 114.472",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.13 64.5624C1546.8 60.6044 1536.33 52.7727 1528.98 45.8112C1516.24 33.7128 1510.18 19.5091 1524.93 12.0423C1528.49 10.2317 1526.84 6.14745 1522.49 6.2457C1493.71 6.91939 1486.61 40.969 1513.24 63.622",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1567.99 76.9275C1573.21 81.1802 1583.19 89.2505 1591.61 94.5699C1606.48 103.959 1621.72 106.36 1625.34 90.2189C1626.21 86.3171 1630.59 86.9206 1631.56 91.1593C1637.96 119.216 1606.67 134.458 1578.19 114.191",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.425 706.621C525.471 706.621 534.425 697.667 534.425 686.621C534.425 675.575 525.471 666.621 514.425 666.621C503.379 666.621 494.424 675.575 494.424 686.621C494.424 697.667 503.379 706.621 514.425 706.621Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.366 36.0848C647.342 36.0848 652.998 30.4293 652.998 23.453C652.998 16.4767 647.342 10.8212 640.366 10.8212C633.389 10.8212 627.734 16.4767 627.734 23.453C627.734 30.4293 633.389 36.0848 640.366 36.0848Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.504 685.597C805.481 685.597 811.136 679.941 811.136 672.965C811.136 665.988 805.481 660.333 798.504 660.333C791.528 660.333 785.872 665.988 785.872 672.965C785.872 679.941 791.528 685.597 798.504 685.597Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.065 476.681C148.041 476.681 153.697 471.026 153.697 464.049C153.697 457.073 148.041 451.417 141.065 451.417C134.088 451.417 128.433 457.073 128.433 464.049C128.433 471.026 134.088 476.681 141.065 476.681Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.42 818.763C1604.47 818.763 1613.42 809.809 1613.42 798.763C1613.42 787.717 1604.47 778.763 1593.42 778.763C1582.38 778.763 1573.42 787.717 1573.42 798.763C1573.42 809.809 1582.38 818.763 1593.42 818.763Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.51 83.4539C464.556 83.4539 473.511 74.4995 473.511 63.4536C473.511 52.4078 464.556 43.4533 453.51 43.4533C442.464 43.4533 433.51 52.4078 433.51 63.4536C433.51 74.4995 442.464 83.4539 453.51 83.4539Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.43 63.4536C1251.47 63.4536 1260.43 54.4992 1260.43 43.4533C1260.43 32.4074 1251.47 23.453 1240.43 23.453C1229.38 23.453 1220.43 32.4074 1220.43 43.4533C1220.43 54.4992 1229.38 63.4536 1240.43 63.4536Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.606 90.4716C914.606 90.4716 851.278 122.486 837.79 92.4646C818.758 50.078 925.203 10.1896 942.846 44.8147C954.734 68.1695 932.361 79.0468 932.333 79.1591C933.961 84.9276 936.221 89.5593 939.519 93.026C941.611 95.2295 939.941 98.8787 936.895 98.7384C928.993 98.3594 921.287 94.9488 914.606 90.4716Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.394 68.3379C862.787 66.6817 855.952 68.6467 856.345 74.2047C856.569 77.3486 859.419 79.3556 864.752 79.3556C870.451 79.3556 874.184 82.668 873.216 86.8084C872.205 91.1312 865.707 93.0962 861.833 91.2856",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.532 59.3553C882.226 59.8325 875.56 61.6571 874.745 63.5799C873.931 65.5028 880.668 82.7662 882.886 84.0715C885.104 85.3908 893.146 80.9697 893.146 80.9697",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.777 74.2889C880.949 73.3204 886.395 70.9485 886.395 70.9485",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.276 55.7202C891.462 57.643 898.55 75.7766 900.753 77.0959C902.971 78.4152 911.013 73.9941 911.013 73.9941",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.171 48.7166C909.357 50.6394 916.445 68.773 918.649 70.0923C920.866 71.4116 928.909 66.9905 928.909 66.9905",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.128 509.992C903.484 509.398 908.852 501.551 908.119 492.464C907.385 483.378 900.827 476.493 893.471 477.087C886.115 477.681 880.747 485.529 881.481 494.615C882.214 503.702 888.772 510.587 896.128 509.992Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.903 541.882C944.259 541.288 949.627 533.44 948.894 524.354C948.16 515.267 941.602 508.383 934.246 508.977C926.89 509.571 921.522 517.418 922.255 526.505C922.989 535.591 929.547 542.476 936.903 541.882Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.423 545.468C890.858 544.051 938.818 475.614 938.818 475.614",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.469 115.805C139.521 95.1032 173.655 59.622 166.273 61.4746C158.708 63.3975 151.199 65.5028 143.732 67.7765C140.7 68.7168 142.51 75.9591 138.833 77.0679C132.18 79.0889 129.022 62.9203 134.735 59.4395C140.447 55.9588 160.56 49.8113 174.189 48.6885C187.817 47.5656 167.648 68.0572 167.213 89.3628C167.059 98.2752 172.238 106.388 171.213 111.889C170.217 117.433 163.578 121.391 158.469 115.805Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.625 100.268C195.677 79.5661 229.812 44.0849 222.429 45.9375C214.864 47.8604 207.355 49.9657 199.888 52.2394C196.856 53.1798 198.667 60.422 194.989 61.5308C188.337 63.5518 185.179 47.3832 190.891 43.9024C196.604 40.4217 216.716 34.2742 230.345 33.1514C243.988 32.0426 223.804 52.5201 223.369 73.8257C223.215 82.7381 228.394 90.8505 227.369 96.3524C226.387 101.91 219.734 105.854 214.625 100.268Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.795 84.7452C251.847 64.0431 285.982 28.5618 278.599 30.4145C271.034 32.3373 263.525 34.4426 256.058 36.7164C253.026 37.6567 254.837 44.8989 251.16 46.0077C244.507 48.0288 241.349 31.8601 247.061 28.3794C252.774 24.8986 272.887 18.7512 286.515 17.6283C300.158 16.5196 279.975 36.9971 279.54 58.3027C279.385 67.2151 284.564 75.3275 283.54 80.8293C282.543 86.3873 275.904 90.3312 270.795 84.7452Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.13 650.775C1033.54 657.386 1029.47 664.389 1031.45 668.81C1033.43 673.231 1041.38 674.846 1049.36 675.814",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.45 668.81L1061.1 655.519",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.961 217.631C183.817 210.221 180.056 203.035 175.269 202.361C170.483 201.687 164.869 207.526 159.788 213.772",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.27 202.361L170.694 234.516",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.023 38.1058C994.581 46.0077 996.771 53.7973 1001.32 55.4535C1005.87 57.1096 1012.56 52.5341 1018.82 47.4674",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.32 55.4535L1012.41 24.9127",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378.31 694.804C1392.01 689.204 1376.69 664.08 1368.04 667.603C1359.41 671.14 1357.29 673.021 1350.87 668.824C1336.91 659.673 1324.12 628.431 1327.69 612.094C1329.33 604.599 1332.15 604.458 1340.8 600.936C1349.43 597.399 1342.76 568.739 1329.08 574.325C1277.36 595.476 1326.56 715.955 1378.31 694.804Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.644 1111.18C994.876 1109.41 994.385 1104.56 992.209 1100.75C978.131 1076.17 944.937 1040.17 927.379 1023.93C916.993 1014.33 912.501 1015.1 907.069 1026.29C897.174 1046.61 879.04 1094.46 875.195 1123.83C874.619 1128.19 876.009 1132.85 882.451 1132.13C901.848 1129.95 971.479 1116.06 988.644 1111.18Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.842 1054.85L934.986 1066.23",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.569 1064.62L951.52 1074.32",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.67 1066.53C903.462 1070.71 900.417 1092.34 900.417 1092.34C914.719 1107.69 949.499 1100.89 956.924 1081.2C956.91 1081.2 945.878 1062.35 924.67 1066.53Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.315 1084.76C919.575 1075.93 932.937 1073.28 934.677 1082.12C936.418 1090.96 923.07 1093.62 921.315 1084.76Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.89 1059.96L914.999 1070.18",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.511 1077.27L902.774 1083.93",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 815.69C1659.8 806.918 1653.23 793.079 1651.53 776.068C1649.23 752.966 1656.67 729.471 1670 715.829V708.207C1652.81 722.383 1643.21 749.317 1645.94 776.63C1647.98 797.051 1656.61 813.36 1670 822.792V815.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 1123.81C1669.96 1123.81 1669.93 1123.82 1669.89 1123.82C1668.37 1123.88 1665.44 1121.8 1661.97 1115.93C1654.97 1104.12 1651.57 1087.34 1654.97 1081.42C1659.35 1073.8 1664.68 1065.21 1669.99 1056.93V1041.19C1669.78 1044.79 1669.34 1047.17 1669.23 1047.75C1662.63 1057.9 1655.63 1069 1650.1 1078.63C1644.72 1087.99 1650.73 1107.97 1657.13 1118.8C1660.03 1123.71 1664.57 1129.56 1669.99 1129.43V1123.81H1670Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670 1033.11V1009.36C1665.09 997.826 1656.13 986.036 1640.03 977.517C1640.5 976.955 1640.9 976.394 1641.28 975.804C1651.92 978.822 1661.19 984.689 1666.91 992.127C1667.46 992.843 1668.3 993.222 1669.13 993.222C1669.42 993.222 1669.71 993.18 1669.99 993.082V987.033C1663.6 979.58 1654.1 973.713 1643.33 970.555C1643.37 970.303 1643.42 970.036 1643.44 969.783L1643.87 969.91C1653.3 972.689 1661.96 975.243 1670 978.682V972.618C1662.24 969.474 1654.06 967.06 1645.45 964.534L1643.26 963.888C1641.93 956.45 1636.79 949.081 1631.47 945.165C1630.6 930.779 1627.35 915.789 1610.39 912.926C1591.13 909.656 1576.66 923.074 1562.32 938.316C1544.13 957.629 1534.54 985.433 1537.9 1009.12C1539.27 1018.84 1542.73 1027.08 1547.88 1033.24C1547.92 1033.29 1547.96 1033.35 1548 1033.41C1550.47 1036.34 1553.34 1038.79 1556.55 1040.7C1560.35 1042.95 1564.03 1044.09 1567.54 1044.09C1569.11 1044.09 1570.66 1043.86 1572.16 1043.4C1582.6 1040.21 1589.01 1026.72 1595.2 1013.69C1599.81 1003.99 1604.57 993.966 1610.21 990.541C1610.39 990.429 1610.56 990.303 1610.7 990.148C1618.32 989.994 1628.67 986.822 1635.67 981.615C1662.94 995.159 1669.13 1018.09 1670 1033.11ZM1625.63 942.33C1624.51 942.064 1623.43 941.979 1622.41 942.064C1621.9 932.435 1617.97 924 1611.56 918.919C1621.34 921.544 1624.52 930.134 1625.63 942.33ZM1611.54 926.877C1615.02 931.453 1616.93 937.755 1616.83 944.716C1616.37 945.179 1615.94 945.713 1615.54 946.302C1610.9 953.222 1601 970.962 1599.16 980.633C1591.85 985.727 1586.5 995.468 1581.34 1004.91C1576.69 1013.4 1571.89 1022.18 1567.27 1023.31C1566.45 1023.52 1565.11 1023.64 1563.09 1022.3C1558.77 1019.44 1555.69 1013.67 1554.46 1006.06C1552.26 992.464 1556.02 970.12 1573.18 948.211C1586.57 931.172 1598.76 924.379 1611.54 926.877ZM1552.12 1029.56C1547.68 1024.21 1544.68 1016.94 1543.46 1008.32C1540.34 986.247 1549.35 960.267 1566.42 942.148C1574.99 933.039 1583.57 924.646 1593.02 920.604C1596.76 919.411 1600.51 919.523 1603.93 920.898C1592.12 921.909 1580.54 929.783 1568.78 944.772C1553.24 964.59 1545.81 987.847 1548.93 1006.99C1550.42 1016.16 1554.35 1023.27 1560 1027.01C1561.03 1027.68 1562.07 1028.2 1563.11 1028.54C1560.9 1030.04 1558.82 1030.92 1556.99 1031.1C1555.2 1031.27 1553.59 1030.75 1552.12 1029.56ZM1590.14 1011.26C1584.47 1023.2 1578.6 1035.54 1570.53 1038.01C1567.39 1038.98 1563.95 1038.36 1560.05 1036.2C1566.54 1034.37 1572.5 1028.31 1576.54 1023.2C1579.89 1019.24 1582.95 1013.67 1586.26 1007.61C1590.43 999.987 1595.09 991.496 1600.52 986.696C1601.24 987.58 1602.18 988.338 1603.36 988.899C1598.29 994.078 1594.31 1002.47 1590.14 1011.26ZM1637.28 971.453C1633.65 980.212 1614.05 986.373 1606.57 984.127C1604.99 983.65 1604.62 983.047 1604.59 982.443C1604.59 982.373 1604.59 982.289 1604.59 982.219C1604.61 982.036 1604.64 981.868 1604.66 981.699C1606.14 973.924 1614.85 957.39 1620.2 949.432C1620.76 948.604 1622.25 946.372 1626.45 948.604C1633.52 952.351 1640.16 964.338 1637.28 971.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.46 757.822C216.015 753.05 213.039 749.233 209.278 747.099C214.78 743.141 217.615 737.822 217.39 731.646C217.095 723.309 214.709 717.232 210.134 713.064C201.895 705.583 188.758 706.397 176.055 707.169C165.024 707.842 154.609 708.488 150.553 703.253C147.451 699.267 147.76 691.393 151.465 679.842C157.122 662.228 154.96 644.627 145.697 632.74C139.83 625.231 131.745 621.034 124.054 621.539C119.534 621.834 116.348 623.238 114.313 625.806C110.509 630.592 111.745 637.961 113.303 647.294C116.138 664.235 120.011 687.435 93.8492 706.018C92.8808 706.706 91.9404 707.435 91.0281 708.193V715.815C92.9369 713.864 94.9721 712.109 97.1055 710.593C126.131 689.976 121.752 663.729 118.847 646.368C117.569 638.733 116.475 632.122 118.72 629.287C119.717 628.024 121.598 627.322 124.433 627.125C130.286 626.732 136.573 630.129 141.289 636.178C149.416 646.592 151.227 662.27 146.146 678.116C141.71 691.912 141.71 700.993 146.146 706.692C152.027 714.257 163.887 713.541 176.434 712.769C187.972 712.067 199.916 711.323 206.4 717.218C209.811 720.306 211.579 725.092 211.818 731.843C212.099 739.394 205.628 743.534 200.14 745.668C183.48 752.18 155.128 748.713 146.904 739.141C144.335 736.152 143.928 731.548 145.893 727.941C149.107 722.046 158.918 722.271 168.406 722.495C174.722 722.636 181.249 722.804 186.315 721.162C187.789 720.685 188.603 719.099 188.126 717.625C187.649 716.151 186.063 715.337 184.589 715.815C180.421 717.162 174.385 717.022 168.546 716.881C157.374 716.614 145.823 716.348 140.967 725.246C137.851 730.945 138.524 738.004 142.637 742.79C144.321 744.755 146.525 746.468 149.107 747.927C143.97 750.734 140.447 755.955 140.012 762.019C139.844 764.32 140.181 766.833 141.163 769.289C125.766 779.801 109.723 777.837 101.358 775.647C99.8564 775.254 98.3266 776.152 97.9336 777.654C97.5406 779.156 98.4388 780.686 99.9407 781.079C103.702 782.061 108.867 783.016 114.804 783.016C123.506 783.016 133.879 780.994 144.054 774.117C145.275 775.577 146.819 776.924 148.7 778.131C143.689 781.135 140.223 786.258 139.816 791.984C139.451 796.981 141.36 801.416 145.121 804.742C140.924 809.444 138.145 816.321 140.447 822.876C141.261 825.178 142.791 827.662 145.528 829.978C134.23 829.893 115.689 828.644 101.344 822.244C97.5827 820.574 94.144 818.356 91.0421 815.676V822.778C93.5545 824.546 96.2212 826.104 99.0704 827.367C114.917 834.427 134.959 835.62 146.581 835.62C151.044 835.62 154.23 835.451 155.507 835.367C161.388 837.416 169.375 838.904 180.196 839.311C180.519 839.325 180.856 839.325 181.178 839.325C190.344 839.325 197.516 834.385 200.463 825.978C202.358 820.574 202.119 814.707 200.126 810.862C203.27 809.276 205.867 807.17 207.818 804.56C212.59 798.16 212.478 789.738 207.551 782.58C207.509 782.524 207.453 782.468 207.411 782.412C209.446 781.247 211.018 779.998 212.197 778.833C217.699 773.387 219.734 765.331 217.46 757.822ZM195.116 824.139C193.81 827.872 190.175 834.062 180.364 833.711C169.782 833.318 162.385 831.9 157.206 830.09C156.967 829.964 156.714 829.865 156.448 829.809C149.177 827.086 146.595 823.535 145.697 821.023C144.068 816.42 146.567 811.227 149.823 807.9C150.96 808.462 152.181 808.967 153.486 809.388C164.125 812.841 173.838 814.539 182.175 814.539C186.849 814.539 191.074 813.991 194.793 812.925C196.098 814.735 196.8 819.339 195.116 824.139ZM203.27 801.219C197.923 808.391 182.498 812.883 155.227 804.04C148.588 801.893 144.995 797.64 145.374 792.391C145.711 787.83 149.36 782.665 155.718 781.303C168.785 785.444 179.101 786.987 187.2 786.987C193.544 786.987 198.526 786.033 202.428 784.658C202.498 785.051 202.639 785.43 202.877 785.78C206.456 790.974 206.611 796.742 203.27 801.219ZM156.813 775.759C156.743 775.731 156.658 775.703 156.588 775.675C149.262 773.261 145.149 768.321 145.584 762.426C145.977 756.938 150.118 752.461 155.648 751.52C155.985 751.464 156.293 751.338 156.574 751.184C170.624 755.857 189.923 755.675 202.162 750.889C202.414 750.79 202.639 750.678 202.891 750.58C203.172 750.748 203.481 750.889 203.832 750.959C207.565 751.675 210.737 754.917 212.099 759.436C213.797 765.022 212.337 770.777 208.211 774.833C203.214 779.745 189.909 786.384 156.813 775.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.069 1076.63C155.592 1075.86 155.002 1074.8 154.314 1073.56C149.416 1064.77 144.953 1057.55 139.717 1057.8C138.047 1057.88 135.703 1058.81 134.075 1062.65C132.573 1066.19 130.763 1068.3 129.107 1068.44C128.068 1068.52 125.134 1067.93 120.348 1060.48C119.829 1059.67 119.324 1058.85 118.861 1058.05C125.303 1048.86 133.233 1038.08 136.082 1035.06C136.096 1035.05 136.096 1035.03 136.11 1035.03C136.728 1034.37 137.289 1033.6 137.724 1032.7C141.065 1025.87 138.089 1014.72 129.738 1002.89C118.299 986.724 105.372 978.429 91 972.618V978.682C103.814 984.141 115.015 991.819 125.12 1006.15C133.542 1018.09 134.44 1026.6 132.658 1030.25C132.503 1030.57 132.293 1030.91 132.026 1031.19C132.012 1031.2 131.998 1031.22 131.984 1031.23C131.97 1031.24 131.942 1031.27 131.928 1031.29C131.633 1031.55 131.282 1031.76 130.861 1031.78C129.921 1031.83 128.391 1031.01 126.931 1028.61C122.552 1021.41 116.376 1017.8 111.239 1019.4C109.218 1020.03 107.618 1021.38 106.495 1023.29C106.481 1023.3 106.481 1023.31 106.467 1023.33C103.913 1027.13 100.46 1032.25 96.6002 1038.08C96.6142 1030.58 95.5616 1020.06 91 1009.33V1032.96C91.1825 1036.13 91.1404 1038.94 91 1041.25V1056.94C95.9265 1049.27 100.839 1041.83 104.965 1035.64C105.695 1041.12 108.039 1051.74 115.618 1063.53C120.419 1070.99 124.98 1074.43 129.584 1074.04C132.307 1073.8 136.209 1072.02 139.24 1064.86C139.633 1063.92 139.956 1063.55 140.096 1063.43C141.71 1063.76 144.84 1068.09 149.416 1076.3C150.16 1077.62 150.791 1078.77 151.297 1079.6C153.556 1083.46 150.398 1117.32 145.753 1131.67C145.668 1131.89 144.854 1132.73 142.356 1133.55C134.987 1135.98 122.608 1135.57 120.573 1134.26C119.647 1133.67 118.552 1129.42 117.822 1126.61C116.348 1120.92 114.538 1113.95 110.144 1108.69C114.496 1101.38 120.194 1093.31 124.447 1087.3L126.622 1084.23C127.521 1082.96 127.212 1081.21 125.934 1080.31C124.671 1079.41 122.917 1079.72 122.019 1081L119.857 1084.06C115.197 1090.63 108.839 1099.62 104.264 1107.6C102.65 1109.98 101.33 1112.45 100.179 1114.64C97.0353 1120.58 95.1826 1123.69 91 1123.83V1129.46C98.7617 1129.31 102.004 1123.19 105.134 1117.28C105.737 1116.16 106.341 1115.01 106.986 1113.86C109.794 1118.05 111.197 1123.5 112.376 1128.03C113.71 1133.17 114.762 1137.22 117.527 1139.01C119.548 1140.3 124.04 1140.94 129.036 1140.94C134.468 1140.94 140.517 1140.19 144.658 1138.71C148.181 1137.45 150.342 1135.67 151.072 1133.42C155.086 1121.06 160.181 1083.29 156.069 1076.63ZM110.285 1032.37C110.144 1029.81 110.467 1027.72 111.183 1026.36C111.225 1026.29 111.267 1026.22 111.295 1026.15C111.716 1025.43 112.264 1024.96 112.895 1024.75C115.029 1024.07 118.889 1026.19 122.131 1031.51C123.633 1033.97 125.499 1035.72 127.521 1036.65C124.208 1040.93 119.927 1046.8 115.899 1052.48C111.267 1042.71 110.425 1034.92 110.285 1032.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3614 988.703C91.9263 988.142 91.4772 987.58 91 987.033V993.082C91.2947 992.984 91.5895 992.843 91.8562 992.633C93.0773 991.692 93.3018 989.924 92.3614 988.703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.65 275.579L1523.38 261.193C1519.21 259.537 1514.54 259.607 1510.42 261.39L1474.6 276.871C1470.48 278.653 1467.24 281.994 1465.58 286.176L1451.19 322.443C1449.54 326.612 1449.61 331.286 1451.39 335.398L1466.87 371.216C1468.65 375.342 1471.99 378.584 1476.18 380.241L1512.44 394.627C1516.61 396.283 1521.29 396.213 1525.4 394.43L1561.22 378.949C1565.34 377.167 1568.59 373.826 1570.24 369.644L1584.63 333.377C1586.29 329.208 1586.22 324.535 1584.43 320.422L1568.95 284.604C1567.17 280.478 1563.81 277.236 1559.65 275.579Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545.86 292.857L1521.57 283.215C1518.77 282.106 1515.64 282.148 1512.88 283.341L1488.88 293.713C1486.11 294.906 1483.94 297.152 1482.83 299.945L1473.2 324.24C1472.09 327.033 1472.13 330.163 1473.33 332.928L1483.7 356.928C1484.89 359.693 1487.14 361.868 1489.93 362.977L1514.23 372.605C1517.02 373.714 1520.15 373.672 1522.91 372.479L1546.92 362.107C1549.68 360.914 1551.86 358.668 1552.97 355.875L1562.59 331.58C1563.7 328.787 1563.66 325.657 1562.47 322.892L1552.09 298.892C1550.9 296.127 1548.67 293.966 1545.86 292.857Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.68 283.776L1481.23 292.155",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581.08 326.766L1569.12 327.005",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.25 371.735L1554.69 363.356",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454.86 328.745L1466.81 328.521",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454.86 328.745L1466.81 328.521",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.25 371.735L1554.69 363.356",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.77 390.978L1518.54 379.006",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.75 282.569L1553.37 291.13",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1474.17 373.279L1482.55 364.732",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.15 264.884L1517.38 276.857",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.05 311.243L1484.61 338.654",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.69 325.742L1491.05 345.896",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.89 320.464L1544.96 322.598",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7_2689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9592 643.743L-60.598 581.609",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9808 624.192L-46.5625 562.058",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2436 666.214L-71.3632 593.988C-76.2476 590.479 -77.3565 583.686 -73.8616 578.802L-53.4679 550.38C-49.959 545.496 -43.1658 544.387 -38.2814 547.882L62.3253 620.108L-15.5859 728.629L-116.193 656.403C-121.077 652.894 -122.186 646.101 -118.691 641.217L-98.2975 612.795C-94.7886 607.911 -87.9954 606.802 -83.111 610.297L17.4958 682.523",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.0607 146.922C-31.39 141.027 -19.0389 133.518 -10.4913 125.7C-9.9158 128.732 -8.48416 132.156 -6.26654 135.455C-1.21374 142.964 6.01459 146.936 9.8884 144.325C13.7622 141.728 12.7939 133.532 7.74109 126.023C4.63923 121.419 0.723182 118.149 -2.7436 116.9C5.29877 103.777 -1.39608 83.3136 -18.5896 69.9239C-35.7692 56.5482 -57.2296 55.0745 -67.9949 66.0642C-70.0722 63.0466 -74.1564 60.0851 -79.3356 58.2325C-87.8551 55.1728 -96.0239 56.2535 -97.6099 60.6465C-99.1959 65.0396 -93.5536 71.0748 -85.048 74.1204C-81.3567 75.4398 -77.7355 75.9871 -74.6757 75.8327C-80.1496 86.0364 -84.3744 99.805 -86.7323 114.472",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.0105 76.9275C-5.78926 81.1802 4.19014 89.2505 12.6115 94.5699C27.4752 103.959 42.7178 106.36 46.339 90.2189C47.2092 86.3171 51.5882 86.9206 52.5567 91.1593C58.9569 119.216 27.6716 134.458 -0.806608 114.191",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4219 818.763C25.468 818.763 34.4226 809.809 34.4226 798.763C34.4226 787.717 25.468 778.763 14.4219 778.763C3.37587 778.763 -5.57874 787.717 -5.57874 798.763C-5.57874 809.809 3.37587 818.763 14.4219 818.763Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 815.69C80.7961 806.918 74.2275 793.079 72.5292 776.068C70.2273 752.966 77.6662 729.471 91 715.829V708.207C73.8064 722.383 64.2061 749.317 66.943 776.63C68.9782 797.051 77.6101 813.36 91 822.792V815.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 1123.81C90.9579 1123.81 90.9299 1123.82 90.8878 1123.82C89.3719 1123.88 86.4385 1121.8 82.9717 1115.93C75.968 1104.12 72.5714 1087.34 75.968 1081.42C80.3471 1073.8 85.6805 1065.21 90.986 1056.93V1041.19C90.7754 1044.79 90.3403 1047.17 90.228 1047.75C83.6313 1057.9 76.6276 1069 71.0976 1078.63C65.722 1087.99 71.7292 1107.97 78.1294 1118.8C81.0347 1123.71 85.5682 1129.56 90.986 1129.43V1123.81H91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 1033.11V1009.36C86.0876 997.826 77.1329 986.036 61.0342 977.517C61.4973 976.955 61.9044 976.394 62.2833 975.804C72.9223 978.822 82.1857 984.689 87.9122 992.127C88.4596 992.843 89.3017 993.222 90.1298 993.222C90.4245 993.222 90.7052 993.18 90.9859 993.082V987.033C84.5998 979.58 75.0977 973.713 64.3325 970.555C64.3746 970.303 64.4166 970.036 64.4447 969.783L64.8658 969.91C74.2977 972.689 82.9576 975.243 91 978.682V972.618C83.2383 969.474 75.0556 967.06 66.4519 964.534L64.2622 963.888C62.9288 956.45 57.792 949.081 52.4725 945.165C51.6023 930.779 48.346 915.789 31.3911 912.926C12.1344 909.656 -2.33629 923.074 -16.6806 938.316C-34.8707 957.629 -44.457 985.433 -41.1025 1009.12C-39.727 1018.84 -36.2743 1027.08 -31.1232 1033.24C-31.0811 1033.29 -31.0391 1033.35 -30.997 1033.41C-28.5267 1036.34 -25.6633 1038.79 -22.4492 1040.7C-18.6456 1042.95 -14.9683 1044.09 -11.4594 1044.09C-9.88745 1044.09 -8.34349 1043.86 -6.84168 1043.4C3.60076 1040.21 10.0149 1026.72 16.2046 1013.69C20.8082 1003.99 25.5664 993.966 31.2086 990.541C31.3911 990.429 31.5595 990.303 31.6999 990.148C39.3212 989.994 49.6654 986.822 56.6691 981.615C83.9402 995.159 90.1298 1018.09 91 1033.11ZM46.6337 942.33C45.5108 942.064 44.43 941.979 43.4054 942.064C42.9002 932.435 38.9702 924 32.556 918.919C42.3388 921.544 45.5249 930.134 46.6337 942.33ZM32.542 926.877C36.0228 931.453 37.9316 937.755 37.8334 944.716C37.3702 945.179 36.935 945.713 36.542 946.302C31.8963 953.222 22.0013 970.962 20.1627 980.633C12.8502 985.727 7.50252 995.468 2.33744 1004.91C-2.30832 1013.4 -7.10833 1022.18 -11.726 1023.31C-12.5541 1023.52 -13.8876 1023.64 -15.9088 1022.3C-20.2317 1019.44 -23.3053 1013.67 -24.5405 1006.06C-26.7441 992.464 -22.9826 970.12 -5.81712 948.211C7.57279 931.172 19.7556 924.379 32.542 926.877ZM-26.8845 1029.56C-31.3197 1024.21 -34.3234 1016.94 -35.5445 1008.32C-38.6604 986.247 -29.6496 960.267 -12.5823 942.148C-4.00663 933.039 4.56919 924.646 14.0151 920.604C17.7626 919.411 21.5101 919.523 24.9348 920.898C13.1169 921.909 1.53748 929.783 -10.2243 944.772C-25.7616 964.59 -33.1865 987.847 -30.0706 1006.99C-28.5828 1016.16 -24.6528 1023.27 -18.9965 1027.01C-17.9719 1027.68 -16.9333 1028.2 -15.8947 1028.54C-18.0983 1030.04 -20.1755 1030.92 -22.0142 1031.1C-23.7967 1031.27 -25.4107 1030.75 -26.8845 1029.56ZM11.1378 1011.26C5.4674 1023.2 -0.399418 1035.54 -8.46985 1038.01C-11.6138 1038.98 -15.0525 1038.36 -18.9544 1036.2C-12.4559 1034.37 -6.50484 1028.31 -2.4626 1023.2C0.891891 1019.24 3.95155 1013.67 7.26393 1007.61C11.4325 999.987 16.0923 991.496 21.5241 986.696C22.2399 987.58 23.1803 988.338 24.3593 988.899C19.2925 994.078 15.3063 1002.47 11.1378 1011.26ZM58.2831 971.453C54.6479 980.212 35.0544 986.373 27.5735 984.127C25.9875 983.65 25.6225 983.047 25.5944 982.443C25.5944 982.373 25.5944 982.289 25.5944 982.219C25.6085 982.036 25.6364 981.868 25.6645 981.699C27.1382 973.924 35.8544 957.39 41.2019 949.432C41.7634 948.604 43.2511 946.372 47.4477 948.604C54.5216 952.351 61.1604 964.338 58.2831 971.453Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.354 275.579L-55.6219 261.193C-59.7905 259.537 -64.4643 259.607 -68.5767 261.39L-104.395 276.871C-108.522 278.653 -111.764 281.994 -113.42 286.176L-127.807 322.443C-129.463 326.612 -129.393 331.286 -127.61 335.398L-112.129 371.216C-110.347 375.342 -107.006 378.584 -102.823 380.241L-66.5556 394.627C-62.3871 396.283 -57.7132 396.213 -53.6008 394.43L-17.7821 378.949C-13.6556 377.167 -10.4134 373.826 -8.75721 369.644L5.62923 333.377C7.28543 329.208 7.21527 324.535 5.43276 320.422L-10.0485 284.604C-11.831 280.478 -15.1855 277.236 -19.354 275.579Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07825 326.766L-9.88 327.005",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_7_2689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1890.82 530.773C1817.16 476.33 1805.22 513.173 1826.88 526.226C1826.88 526.226 1806.2 559.882 1790.54 585.384C1779.35 579.532 1773.51 580.472 1769.54 586.942C1765.82 593.006 1768.18 600.388 1777.72 606.241C1775.45 609.946 1771.55 616.304 1767.8 622.396C1760.68 633.975 1792.53 652.824 1799.32 641.764C1802.16 637.147 1806.24 630.494 1808.87 626.241C1828.63 638.494 1844.9 649.919 1852.35 637.806C1859.66 625.89 1844.18 617.778 1822.3 604.388C1823.89 601.82 1826.89 596.907 1828.39 594.479C1867.45 621.666 1892.9 617.694 1908.37 597.469C1921.05 580.865 1922.81 554.423 1890.82 530.773ZM1877.42 577.847C1870.65 587.139 1857.46 586.662 1840.76 574.395C1838.61 572.823 1856.77 545.089 1857.47 545.412C1881.38 556.823 1884.56 568.037 1877.42 577.847Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1978.99 477.182C2015.55 464.586 2040.12 439.669 2033.86 421.53C2027.61 403.39 1992.91 398.897 1956.35 411.494C1919.8 424.091 1895.23 449.008 1901.48 467.147C1907.73 485.286 1942.43 489.779 1978.99 477.182Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1956.35 431.389L1909.78 466.056",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1992.96 343.444C1931.03 319.654 1871.24 290.18 1814.66 255.541C1806.65 250.642 1803.66 240.116 1807.9 232.2C1826.54 197.21 1845.18 162.22 1863.82 127.23C1868.06 119.3 1877.61 116.816 1885.28 121.518C1939.45 154.88 1996.82 183.161 2056.27 205.828C2064.68 209.028 2068.53 218.137 2064.82 226.333C2048.41 262.418 2032.01 298.517 2015.6 334.602C2011.88 342.77 2001.72 346.812 1992.96 343.444Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1857.66 138.767C1849.53 152.901 1851.17 161.252 1858.32 168.269C1875.37 185.027 1902.46 208.256 1920.69 222.081",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1938.08 253.379L1919.52 244.228C1915.19 242.095 1913.4 236.846 1915.54 232.509L1922.81 217.758C1924.94 213.421 1930.19 211.638 1934.53 213.772L1953.08 222.923C1957.42 225.056 1959.2 230.305 1957.07 234.642L1949.8 249.393C1947.65 253.73 1942.4 255.513 1938.08 253.379Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2039.86 253.814C2029.25 277.113 2018.47 300.734 2008.12 323.542C2004.78 330.91 1999.58 333.76 1991.69 330.728C1936.27 310.208 1877.15 280.594 1826.23 249.435C1819.02 245.028 1817.28 238.895 1821.08 231.765C1832.52 210.291 1844.38 187.891 1856.1 165.827",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950.8 891.48C1960.09 897.824 1972.21 897.235 1980.56 892.322C1988.92 887.41 1989.36 879.929 1993 866.778C1996.64 853.627 1992.66 848.336 1991.09 837.95C1989.52 827.578 1985.48 816.279 1980.89 806.833C1976.3 797.388 1979.36 792.096 1970.56 777.093C1961.76 762.089 1947.48 756.952 1928.97 753.289C1910.46 749.626 1888.56 760.854 1876.86 773.458C1869.98 780.868 1861.59 794.132 1860.69 809.402C1860.22 817.374 1866.5 825.837 1863.49 835.115C1860.5 844.392 1851.72 853.796 1852.07 867.073C1852.36 878.133 1860.64 886.343 1854.27 892.982",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1989.36 880.308C1995.61 890.301 1990.57 899.27 1982.47 906.625C1971.3 916.772 1920.41 923.86 1903.28 886.694C1897.97 875.143 1899.17 869.768 1899.17 869.768",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1905.26 865.698C1903.9 869.964 1893.07 873.627 1886.51 859.648",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1991.6 893.487C1997.6 903.663 2000.14 919.972 1979.95 928.884C1956.87 939.074 1913.88 931.944 1906.68 892.856",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1869.57 914.288C1891.1 919.705 1900.96 900.533 1896.51 886.105C1893.4 876.014 1883.94 879.143 1883.54 870.568C1883.02 859.662 1900.03 841.866 1899.17 817.921C1898.67 803.535 1885.45 795.339 1885.4 783.521C1885.39 779.184 1886.32 770.58 1896.34 767.745C1906.37 764.91 1929.97 759.17 1933.08 754.131",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1914.12 815.858C1921.74 804.223 1933.8 812.195 1940.52 809.163",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1921.9 824.181C1927.81 826.735 1935.44 824.504 1939.1 818.595",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1971.38 946.038C2023.72 929.926 2051.38 868.853 2033.15 809.626C2014.92 750.4 1957.7 715.448 1905.36 731.56C1853.01 747.672 1825.36 808.745 1843.59 867.972C1861.82 927.198 1919.03 962.15 1971.38 946.038Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.14 971.272C2045.12 950.964 2080.35 875.191 2057.83 802.029C2035.31 728.866 1963.57 686.019 1897.59 706.326C1831.61 726.634 1796.39 802.407 1818.91 875.569C1841.43 948.732 1913.17 991.579 1979.14 971.272Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1881.4 1025.1C1868.04 1044.63 1833.99 1055.97 1811.91 1040.87C1789.84 1025.77 1788.05 989.924 1801.41 970.387L1881.4 1025.1Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1817.19 1093.95C1822.36 1086.4 1815.9 1068.61 1800.25 1057.9C1784.6 1047.19 1765.67 1047.64 1760.5 1055.19L1817.19 1093.95Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.39 977.98C1801.61 953.587 1773.95 933.937 1768.05 960.548C1760.95 992.591 1793.93 1010.47 1793.93 1010.47L1795.79 1018.74C1799.96 1032.89 1805.16 1042.44 1795.83 1055.17L1804.4 1061.04C1812.9 1047.72 1823.68 1049.11 1838.38 1047.86L1846.76 1046.58C1846.76 1046.58 1875.38 1070.84 1902.68 1052.61C1925.35 1037.46 1897 1018.81 1876.17 1032.51",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1826.85 1032.21L1814.85 1024L1820.7 1028.02L1835.45 1006.44L1825.89 1007.86",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1813.39 346.953C1817.32 344.833 1821.28 342.742 1825.25 340.665C1827.63 339.43 1830.62 340.749 1831.11 343.275C1831.93 347.514 1832.73 351.809 1833.53 356.16C1833.72 357.255 1834.4 358.209 1835.35 358.77C1839.17 361.002 1842.95 363.234 1846.65 365.437C1848.87 366.757 1849.08 370.013 1847.09 371.837C1843.77 374.869 1840.45 377.858 1837.11 380.834C1836.27 381.578 1835.77 382.659 1835.76 383.795C1835.7 388.329 1835.68 392.848 1835.68 397.339C1835.68 400.034 1833.09 401.845 1830.57 400.918C1826.36 399.389 1822.1 397.859 1817.84 396.357C1816.76 395.978 1815.58 396.062 1814.59 396.596C1810.66 398.715 1806.71 400.806 1802.73 402.883C1800.35 404.118 1797.36 402.799 1796.87 400.273C1796.05 396.034 1795.25 391.739 1794.45 387.388C1794.26 386.294 1793.58 385.339 1792.63 384.778C1788.81 382.546 1785.04 380.315 1781.33 378.111C1779.11 376.792 1778.92 373.536 1780.89 371.711C1784.21 368.679 1787.53 365.69 1790.87 362.714C1791.72 361.97 1792.21 360.89 1792.22 359.753C1792.28 355.22 1792.31 350.7 1792.31 346.209C1792.31 343.514 1794.89 341.703 1797.41 342.63C1801.63 344.16 1805.88 345.69 1810.15 347.191C1811.21 347.57 1812.39 347.486 1813.39 346.953Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.06 476.681C1727.04 476.681 1732.7 471.026 1732.7 464.049C1732.7 457.073 1727.04 451.417 1720.06 451.417C1713.09 451.417 1707.43 457.073 1707.43 464.049C1707.43 471.026 1713.09 476.681 1720.06 476.681Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.47 115.805C1718.52 95.1032 1752.66 59.622 1745.27 61.4746C1737.71 63.3975 1730.2 65.5028 1722.73 67.7765C1719.7 68.7168 1721.51 75.9591 1717.83 77.0679C1711.18 79.0889 1708.02 62.9203 1713.73 59.4395C1719.45 55.9588 1739.56 49.8113 1753.19 48.6885C1766.82 47.5656 1746.65 68.0572 1746.21 89.3628C1746.06 98.2752 1751.24 106.388 1750.21 111.889C1749.22 117.433 1742.58 121.391 1737.47 115.805Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.63 100.268C1774.68 79.5661 1808.81 44.0849 1801.43 45.9375C1793.86 47.8604 1786.35 49.9657 1778.89 52.2394C1775.86 53.1798 1777.67 60.422 1773.99 61.5308C1767.34 63.5518 1764.18 47.3832 1769.89 43.9024C1775.6 40.4217 1795.72 34.2742 1809.34 33.1514C1822.99 32.0426 1802.8 52.5201 1802.37 73.8257C1802.21 82.7381 1807.39 90.8505 1806.37 96.3524C1805.39 101.91 1798.73 105.854 1793.63 100.268Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1849.8 84.7452C1830.85 64.0431 1864.98 28.5618 1857.6 30.4145C1850.03 32.3373 1842.53 34.4426 1835.06 36.7164C1832.03 37.6567 1833.84 44.8989 1830.16 46.0077C1823.51 48.0288 1820.35 31.8601 1826.06 28.3794C1831.77 24.8986 1851.89 18.7512 1865.52 17.6283C1879.16 16.5196 1858.97 36.9971 1858.54 58.3027C1858.39 67.2151 1863.56 75.3275 1862.54 80.8293C1861.54 86.3873 1854.9 90.3312 1849.8 84.7452Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.96 217.631C1762.82 210.221 1759.06 203.035 1754.27 202.361C1749.48 201.687 1743.87 207.526 1738.79 213.772",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.27 202.361L1749.69 234.516",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.46 757.822C1795.01 753.05 1792.04 749.233 1788.28 747.099C1793.78 743.141 1796.61 737.822 1796.39 731.646C1796.1 723.309 1793.71 717.232 1789.13 713.064C1780.89 705.583 1767.76 706.397 1755.06 707.169C1744.02 707.842 1733.61 708.488 1729.55 703.253C1726.45 699.267 1726.76 691.393 1730.47 679.842C1736.12 662.228 1733.96 644.627 1724.7 632.74C1718.83 625.231 1710.75 621.034 1703.05 621.539C1698.53 621.834 1695.35 623.238 1693.31 625.806C1689.51 630.592 1690.74 637.961 1692.3 647.294C1695.14 664.235 1699.01 687.435 1672.85 706.018C1671.88 706.706 1670.94 707.435 1670.03 708.193V715.815C1671.94 713.864 1673.97 712.109 1676.11 710.593C1705.13 689.976 1700.75 663.729 1697.85 646.368C1696.57 638.733 1695.47 632.122 1697.72 629.287C1698.72 628.024 1700.6 627.322 1703.43 627.125C1709.29 626.732 1715.57 630.129 1720.29 636.178C1728.42 646.592 1730.23 662.27 1725.15 678.116C1720.71 691.912 1720.71 700.993 1725.15 706.692C1731.03 714.257 1742.89 713.541 1755.43 712.769C1766.97 712.067 1778.92 711.323 1785.4 717.218C1788.81 720.306 1790.58 725.092 1790.82 731.843C1791.1 739.394 1784.63 743.534 1779.14 745.668C1762.48 752.18 1734.13 748.713 1725.9 739.141C1723.34 736.152 1722.93 731.548 1724.89 727.941C1728.11 722.046 1737.92 722.271 1747.41 722.495C1753.72 722.636 1760.25 722.804 1765.32 721.162C1766.79 720.685 1767.6 719.099 1767.13 717.625C1766.65 716.151 1765.06 715.337 1763.59 715.815C1759.42 717.162 1753.39 717.022 1747.55 716.881C1736.37 716.614 1724.82 716.348 1719.97 725.246C1716.85 730.945 1717.52 738.004 1721.64 742.79C1723.32 744.755 1725.52 746.468 1728.11 747.927C1722.97 750.734 1719.45 755.955 1719.01 762.019C1718.84 764.32 1719.18 766.833 1720.16 769.289C1704.77 779.801 1688.72 777.837 1680.36 775.647C1678.86 775.254 1677.33 776.152 1676.93 777.654C1676.54 779.156 1677.44 780.686 1678.94 781.079C1682.7 782.061 1687.87 783.016 1693.8 783.016C1702.51 783.016 1712.88 780.994 1723.05 774.117C1724.28 775.577 1725.82 776.924 1727.7 778.131C1722.69 781.135 1719.22 786.258 1718.82 791.984C1718.45 796.981 1720.36 801.416 1724.12 804.742C1719.92 809.444 1717.15 816.321 1719.45 822.876C1720.26 825.178 1721.79 827.662 1724.53 829.978C1713.23 829.893 1694.69 828.644 1680.34 822.244C1676.58 820.574 1673.14 818.356 1670.04 815.676V822.778C1672.55 824.546 1675.22 826.104 1678.07 827.367C1693.92 834.427 1713.96 835.62 1725.58 835.62C1730.04 835.62 1733.23 835.451 1734.51 835.367C1740.39 837.416 1748.37 838.904 1759.2 839.311C1759.52 839.325 1759.86 839.325 1760.18 839.325C1769.34 839.325 1776.52 834.385 1779.46 825.978C1781.36 820.574 1781.12 814.707 1779.13 810.862C1782.27 809.276 1784.87 807.17 1786.82 804.56C1791.59 798.16 1791.48 789.738 1786.55 782.58C1786.51 782.524 1786.45 782.468 1786.41 782.412C1788.45 781.247 1790.02 779.998 1791.2 778.833C1796.7 773.387 1798.73 765.331 1796.46 757.822ZM1774.12 824.139C1772.81 827.872 1769.18 834.062 1759.36 833.711C1748.78 833.318 1741.38 831.9 1736.21 830.09C1735.97 829.964 1735.71 829.865 1735.45 829.809C1728.18 827.086 1725.59 823.535 1724.7 821.023C1723.07 816.42 1725.57 811.227 1728.82 807.9C1729.96 808.462 1731.18 808.967 1732.49 809.388C1743.13 812.841 1752.84 814.539 1761.17 814.539C1765.85 814.539 1770.07 813.991 1773.79 812.925C1775.1 814.735 1775.8 819.339 1774.12 824.139ZM1782.27 801.219C1776.92 808.391 1761.5 812.883 1734.23 804.04C1727.59 801.893 1723.99 797.64 1724.37 792.391C1724.71 787.83 1728.36 782.665 1734.72 781.303C1747.79 785.444 1758.1 786.987 1766.2 786.987C1772.54 786.987 1777.53 786.033 1781.43 784.658C1781.5 785.051 1781.64 785.43 1781.88 785.78C1785.46 790.974 1785.61 796.742 1782.27 801.219ZM1735.81 775.759C1735.74 775.731 1735.66 775.703 1735.59 775.675C1728.26 773.261 1724.15 768.321 1724.58 762.426C1724.98 756.938 1729.12 752.461 1734.65 751.52C1734.98 751.464 1735.29 751.338 1735.57 751.184C1749.62 755.857 1768.92 755.675 1781.16 750.889C1781.41 750.79 1781.64 750.678 1781.89 750.58C1782.17 750.748 1782.48 750.889 1782.83 750.959C1786.57 751.675 1789.74 754.917 1791.1 759.436C1792.8 765.022 1791.34 770.777 1787.21 774.833C1782.21 779.745 1768.91 786.384 1735.81 775.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.07 1076.63C1734.59 1075.86 1734 1074.8 1733.31 1073.56C1728.42 1064.77 1723.95 1057.55 1718.72 1057.8C1717.05 1057.88 1714.7 1058.81 1713.08 1062.65C1711.57 1066.19 1709.76 1068.3 1708.11 1068.44C1707.07 1068.52 1704.13 1067.93 1699.35 1060.48C1698.83 1059.67 1698.32 1058.85 1697.86 1058.05C1704.3 1048.86 1712.23 1038.08 1715.08 1035.06C1715.1 1035.05 1715.1 1035.03 1715.11 1035.03C1715.73 1034.37 1716.29 1033.6 1716.72 1032.7C1720.06 1025.87 1717.09 1014.72 1708.74 1002.89C1697.3 986.724 1684.37 978.429 1670 972.618V978.682C1682.81 984.141 1694.01 991.819 1704.12 1006.15C1712.54 1018.09 1713.44 1026.6 1711.66 1030.25C1711.5 1030.57 1711.29 1030.91 1711.03 1031.19C1711.01 1031.2 1711 1031.22 1710.98 1031.23C1710.97 1031.24 1710.94 1031.27 1710.93 1031.29C1710.63 1031.55 1710.28 1031.76 1709.86 1031.78C1708.92 1031.83 1707.39 1031.01 1705.93 1028.61C1701.55 1021.41 1695.38 1017.8 1690.24 1019.4C1688.22 1020.03 1686.62 1021.38 1685.5 1023.29C1685.48 1023.3 1685.48 1023.31 1685.47 1023.33C1682.91 1027.13 1679.46 1032.25 1675.6 1038.08C1675.61 1030.58 1674.56 1020.06 1670 1009.33V1032.96C1670.18 1036.13 1670.14 1038.94 1670 1041.25V1056.94C1674.93 1049.27 1679.84 1041.83 1683.97 1035.64C1684.7 1041.12 1687.04 1051.74 1694.62 1063.53C1699.42 1070.99 1703.98 1074.43 1708.58 1074.04C1711.31 1073.8 1715.21 1072.02 1718.24 1064.86C1718.63 1063.92 1718.96 1063.55 1719.1 1063.43C1720.71 1063.76 1723.84 1068.09 1728.42 1076.3C1729.16 1077.62 1729.79 1078.77 1730.3 1079.6C1732.56 1083.46 1729.4 1117.32 1724.75 1131.67C1724.67 1131.89 1723.85 1132.73 1721.36 1133.55C1713.99 1135.98 1701.61 1135.57 1699.57 1134.26C1698.65 1133.67 1697.55 1129.42 1696.82 1126.61C1695.35 1120.92 1693.54 1113.95 1689.14 1108.69C1693.5 1101.38 1699.19 1093.31 1703.45 1087.3L1705.62 1084.23C1706.52 1082.96 1706.21 1081.21 1704.93 1080.31C1703.67 1079.41 1701.92 1079.72 1701.02 1081L1698.86 1084.06C1694.2 1090.63 1687.84 1099.62 1683.26 1107.6C1681.65 1109.98 1680.33 1112.45 1679.18 1114.64C1676.04 1120.58 1674.18 1123.69 1670 1123.83V1129.46C1677.76 1129.31 1681 1123.19 1684.13 1117.28C1684.74 1116.16 1685.34 1115.01 1685.99 1113.86C1688.79 1118.05 1690.2 1123.5 1691.38 1128.03C1692.71 1133.17 1693.76 1137.22 1696.53 1139.01C1698.55 1140.3 1703.04 1140.94 1708.04 1140.94C1713.47 1140.94 1719.52 1140.19 1723.66 1138.71C1727.18 1137.45 1729.34 1135.67 1730.07 1133.42C1734.09 1121.06 1739.18 1083.29 1735.07 1076.63ZM1689.28 1032.37C1689.14 1029.81 1689.47 1027.72 1690.18 1026.36C1690.23 1026.29 1690.27 1026.22 1690.3 1026.15C1690.72 1025.43 1691.26 1024.96 1691.9 1024.75C1694.03 1024.07 1697.89 1026.19 1701.13 1031.51C1702.63 1033.97 1704.5 1035.72 1706.52 1036.65C1703.21 1040.93 1698.93 1046.8 1694.9 1052.48C1690.27 1042.71 1689.43 1034.92 1689.28 1032.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.36 988.703C1670.93 988.142 1670.48 987.58 1670 987.033V993.082C1670.29 992.984 1670.59 992.843 1670.86 992.633C1672.08 991.692 1672.3 989.924 1671.36 988.703Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1929,
    height: 1080,
    fill: "white",
    transform: "translate(-5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7_2689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1579,
    height: 3419,
    fill: "white",
    transform: "translate(91)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7_2689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1579,
    height: 3419,
    fill: "white",
    transform: "translate(-1488)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_7_2689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1579,
    height: 3419,
    fill: "white",
    transform: "translate(1670)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBg);
export default __webpack_public_path__ + "static/media/auth-bg.e97bbfe90d4a8624bcbd7b3aaf192b5a.svg";
export { ForwardRef as ReactComponent };